import Component from './component';

Component.defaultProps = {
    header: null,
};
export default Component;
